/**
 * @name umi 的路由配置
 * @description 使用自定义 Layout 替代 ProLayout
 */
export default [
  {
    path: '/user',
    layout: false,
    footerRender: false,
    routes: [
      {
        name: '登陆',
        path: '/user/login',
        component: './user/login',
        footerRender: false,
      },
    ],
  },
  // ===== 使用自定义 Layout 的路由 =====
  {
    path: '/',
    wrappers: ['@/wrappers/CustomLayout'],
    routes: [
      {
        path: '/home',
        name: '店铺',
        icon: 'home',
        component: './home',
      },
      {
        path: '/take',
        name: '取号',
        icon: 'history',
        component: './take',
        footerRender: false,
      },
      {
        path: '/order',
        name: '点单',
        icon: 'like',
        footerRender: false,
        component: './order',
      },
      {
        path: '/meal',
        name: '订单',
        icon: 'Profile',
        footerRender: false,
        component: './meal',
      },
      {
        name: '分类',
        path: '/category',
        icon: 'partition',
        component: './categoryManage',
        footerRender: false,
      },
      {
        name: '菜品',
        path: '/item',
        icon: 'appstoreAdd',
        component: './itemManage',
        footerRender: false,
      },
      {
        name: '折扣',
        path: '/discount',
        icon: 'gift',
        component: './discountManage',
        footerRender: false,
      },
      {
        name: '标签',
        path: '/tag',
        icon: 'tags',
        component: './tagManage',
        footerRender: false,
      },
      {
        name: '会员',
        path: '/customer',
        icon: 'user',
        component: './customerManage',
        footerRender: false,
      },
      {
        name: '员工',
        path: '/tenant-invitation',
        icon: 'team',
        component: './invitation/tenant',
        footerRender: false,
      },
      {
        name: '受邀',
        path: '/user-invitation',
        icon: 'mail',
        component: './invitation/user',
        footerRender: false,
        access: 'empty',
      },
      {
        name: '分析',
        path: '/data',
        icon: 'fundView',
        component: './dashbord',
        footerRender: false,
      },
      {
        path: '/',
        redirect: './home',
      },
      {
        path: '/index',
        redirect: '/home',
      },
    ],
  },
  // ===== 无 Layout 的页面 =====
  {
    path: '/403',
    layout: false,
    component: './403',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
